const ViewIntermediaryApply = () => import('../modules/xmsb/energy/operators/ViewIntermediaryApplyGzl')

export default [
  {

    path: '/intermediaryapplyview',
    name: 'intermediaryapplyview',
    component: ViewIntermediaryApply,
    meta: {
      title: '申请海外投资和承包工程保险补贴填写',
      fullscreen: true,
    },
  },
]
